<template>
  <section v-if="order && displayTipSection(order)">
    <div v-if="!includeCssClass">
      <hr>
    </div>
    <div :class="{'card panel-white': includeCssClass}">
      <div :class="{'card-body': includeCssClass}">
        <router-link class="btn btn-block btn-secondary"
                     v-if="$route.matched[0].path !== '/chat-booking'"
                     :to="`/reservation/${order.id}/professional-tip`">
          {{ $t('message.professional_tip.title') }}
        </router-link>

        <button class="btn btn-block btn-secondary"
                @click.prevent="openFormTipModal()"
                v-if="$route.matched[0].path === '/chat-booking'">
          {{ $t('message.professional_tip.title') }}
        </button>

        <!-- Modal -->
        <b-modal v-model="showModal"
                 ref="modal"
                 @ok="submitData">
          <!-- <div> -->
          <div slot="modal-title">
            {{ $t('message.professional_tip.title') }}
          </div>

          <!-- Section Amount -->
          <section>
            <div>
              <label class="mb-0">{{ $t('message.professional_tip.select_amount') }}</label>
              <span class="text-danger" v-if="errorMessages.tip_amount">
                <i class="fas fa-exclamation-circle"></i>
              </span>
            </div>
            <div class="row no-gutters py-2">
              <div class="col-4 p-2" v-for="(tip, index) in tips" :key="index">
                <button
                  class="btn badge badge-pill badge-light text-pro-number text-center w-100"
                  :class="[{'active-button' : selectTip === tip }, 'pillTip']"
                  @click.prevent="assignTip('select', tip)">
                  ฿{{ tip | prettyNumber }}
                </button>
              </div>
            </div>
            <div>
              <div class="py-2 text-secondary">
                {{ $t('message.professional_tip.custom_amount') }}
              </div>
              <input type="number"
                     inputmode="numeric"
                     pattern="[0-9]*"
                     class="form-control"
                     min="20"
                     :max="maxAmount"
                     :placeholder="$t('message.professional_tip.custom_amount_hint')"
                     v-model.number="inputTip"
                     @input="assignTip('input', inputTip)">
              <div class="pt-2 text-remark">
                {{ $t('message.professional_tip.custom_amount_remark') }} {{ maxAmount | prettyNumber }}
              </div>
            </div>
            <div class="py-3">
              <div>
              <span>
                <i class="fas fa-circle bullet-notification"></i> {{ $t('message.professional_tip.remark01') }}
              </span>
              </div>
              <div>
              <span>
                <i class="fas fa-circle bullet-notification"></i> {{ $t('message.professional_tip.remark02') }}
              </span>
              </div>
            </div>
          </section>

          <!-- Section Payment -->
          <section class="pt-3">
            <div>
              <label class="mb-0">{{ $t('message.booking.checkout_step.payment_method') }}</label>
              <span class="text-danger" v-if="errorMessages.payment_method">
                <i class="fas fa-exclamation-circle"></i>
              </span>
            </div>
            <template>
              <div class="card shadow-sm">
                <div class="card-body p-3">
                  <div class="exp">
                    <div class="checkbox">
                      <input
                        type="radio"
                        id="paymentCreditDebit"
                        name="paymentMethod"
                        value="credit_card"
                        v-model="paymentMethod"
                        @change="calculateTip"
                        :disabled="!totalTip"
                      />
                      <label for="paymentCreditDebit" class="mb-0">
                        <span><!-- This span is needed to create the "checkbox" element --></span>
                        {{ $t('message.booking.payment_step.pay_by_credit_debit_card') }}
                      </label>
                      <div class="text-danger text-remark pt-1 pl-4 ml-2">
                        {{ $t('message.professional_tip.credit_card_remark') }}
                      </div>
                    </div>
                  </div>
                  <template v-if="payment">
                    <div class="payment-method" v-if="paymentMethod === 'credit_card'">
                      <payment-small :payment="payment" class="mt-3"/>
                    </div>
                    <template v-if="payment === null">
                      <loader/>
                    </template>
                  </template>
                  <template v-else>
                    <div class="mt-3" v-if="paymentMethod === 'credit_card'">
                      <payment-form ref="paymentForm" :paymentData="paymentData"/>
                    </div>
                  </template>
                </div>
              </div>
              <!-- Payment with promptpay -->
              <div class="card shadow-sm">
                <div class="card-body p-3">
                  <div class="exp" v-if="globalState.configData.promptpay.status === 1">
                    <div class="checkbox">
                      <input
                        type="radio"
                        id="promptpay"
                        ref="promptpay"
                        name="paymentMethod"
                        value="promptpay"
                        v-model="paymentMethod"
                        @change="calculateTip"
                        :disabled="!totalTip"
                      />
                      <label for="promptpay" class="mb-0">
                        <span><!-- This span is needed to create the "checkbox" element --></span>
                        {{ $t('message.booking.payment_step.pay_by_promptpay') }}
                        <img
                          src="/static/img/thai_qr_payment.png"
                          width="90"
                          class="rounded ml-2"
                        />
                      </label>
                    </div>
                  </div>
                  <div v-else>
                    <div class="d-flex align-items-center justify-content-start">
                      <div>
                        <i class="fas fa-circle fa-lg -status-offline"></i>
                      </div>
                      <div class="pl-3">
                        {{ $t('message.booking.payment_step.pay_by_promptpay') }}
                      </div>
                      <div>
                        <img src="/static/img/thai_qr_payment.png" width="90" class="rounded ml-2"/>
                      </div>
                    </div>
                    <div class="pt-3 text-small">
                      {{ ($i18n.locale === 'th') ? globalState.configData.promptpay.remark_th : globalState.configData.promptpay.remark_en }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="paymentMethod === 'promptpay'">
                <qr-code-payment ref="qrCodePayment" @checkQrPayment="checkQrPayment"/>
                <hr/>
                <div class="text-remark">
                  {{ $t('message.promptpay.payment_remark') }}
                </div>
              </div>
            </template>
          </section>

          <!-- Footer Section -->
          <template #modal-footer="{ ok, cancel }">
            <div class="w-100">
              <div class="d-flex justify-content-start align-items-center">
                <div class="flex-grow-1">
                  <label class="mb-0">{{ $t('message.professional_tip.amount') }}</label>
                  <span class="-status-new text-pro-number" v-if="totalTip">{{ totalTip | currency }}</span>
                </div>
                <div class="pr-2">
                  <b-button variant="secondary" @click="closeModal()">
                    {{ $t('message.button.cancel') }}
                  </b-button>
                </div>
                <div>
                  <b-button variant="info"
                            :disabled="isLoading"
                            @click="ok()"
                            v-if="paymentMethod !== 'promptpay'">
                    {{ isLoading ? $t('message.button.loading') : $t('message.button.confirm') }}
                  </b-button>
                </div>
              </div>
            </div>
          </template>
          <!-- </div> -->
        </b-modal>
        <!-- </div> -->
      </div>
    </div>
  </section>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import PaymentForm from '../../payment/PaymentForm.vue'
  import PaymentSmall from '../../payment/PaymentSmall.vue'
  import QrCodePayment from '../../qrPayment/QrCodePayment'
  import axios from 'axios'

  export default {
    components: {PaymentForm, PaymentSmall, QrCodePayment},
    props: {
      order: Object,
      includeCssClass: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        showModal: false,
        tips: [],
        maxAmount: null,
        tipAmount: null,
        selectTip: null,
        inputTip: null,
        paymentMethod: null,
        paymentData: {
          name: null,
          number: null,
          expirationDate: null,
          securityCode: null,
          savePayment: true,
          displaySavePayment: true,
          isDefault: false
        },
        omiseTokens: {
          secureToken: null,
          token: null
        },
        isLoading: false,
        checkingQrPayment: null,
        qrResponse: null,
        totalTip: 0,
        errorMessages: {}
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        payment: 'payment/getPayment',
        user: 'auth/getUser'
      })
    },
    watch: {
      paymentMethod () {
        this.updateQrPaymentData()
      },
      'omiseTokens.token': function (newVal, oldVal) {
        this.isLoading = false
        if (this.omiseTokens.secureToken && this.omiseTokens.token) {
          const returnUri = location.href.split('?')[0] + '?tmpToken=' + this.omiseTokens.token + '&action=professional_tip_payment'
          const submitData = {
            user_id: this.user.id,
            token: this.omiseTokens.secureToken,
            return_uri: returnUri,
            omise_account: 'hellobeneat'
          }
          this.checkOmiseSecure(submitData)
        }
      }
    },
    methods: {
      ...mapActions('orderDetail', ['loadOrderDetail']),
      displayTipSection (order) {
        return (order.paid_status === 1 && order.status === 2 && !order.cancel && !order.professional_tip && order.review_days > 0 && !order.order_report_issue)
      },
      checkInputTip () {
        if (this.inputTip > this.maxAmount) {
          this.inputTip = this.maxAmount
          this.tipAmount = this.maxAmount
          return this.inputTip
        }
      },
      closeModal () {
        clearInterval(this.checkingQrPayment)
        this.paymentMethod = null
        this.totalTip = null
        this.tipAmount = null
        this.inputTip = null
        this.selectTip = null
        this.showModal = false
      },
      clearData () {
        this.paymentMethod = null
        this.totalTip = null
        this.tipAmount = null
        this.inputTip = null
        this.selectTip = null
        this.showModal = false
      },
      calculateTip () {
        this.checkInputTip()
        this.totalTip = this.tipAmount
        if (this.paymentMethod === 'credit_card') {
          // ถ้าเป็น เครดิต + 4%
          let creditCardFee = (4 / 100) * this.tipAmount
          this.totalTip = Number(this.tipAmount) + Number(creditCardFee)
        }
        return this.totalTip
      },
      assignTip (type, tip) {
        this.selectTip = tip
        if (type === 'select') {
          this.inputTip = null
          this.paymentMethod = null
        }
        if (type === 'input') {
          this.selectTip = null
          this.paymentMethod = null
          this.clearClass()
        }
        this.totalTip = tip
        this.tipAmount = tip
        this.calculateTip()
      },
      clearClass () {
        window.$('button.active-button').removeClass('active-button')
      },
      openFormTipModal () {
        this.showModal = true
        this.errorMessages = {}
        this.tips = this.globalState.professionalTipData.professional_tips
        this.maxAmount = Number(this.globalState.professionalTipData.max_amount)
        this.$store.dispatch('payment/LOAD_PAYMENT_DETAIL', this.user.id)
      },
      isValid () {
        this.errorMessages = {}
        let result = true
        if (!this.tipAmount || this.tipAmount < 20) {
          result = false
          this.errorMessages.tip_amount = true
        }
        if (!this.paymentMethod) {
          result = false
          this.errorMessages.payment_method = true
        }
        return result
      },
      async checkOmiseSecure (submitData) {
        const url = 'payments/' + this.user.id + '/check-omise-secure'
        const {data} = await axios.post(url, submitData)
        this.isLoading = false
        this.$store.commit('payment/SET_TMP_OMISE_CHARGE_ID', null)
        if (!data.error) {
          this.closeModal()
          this.$store.commit('payment/SET_TMP_OMISE_CHARGE_ID', data.omise_charge_id)
          window.location = data.authorize_uri
        } else {
          this.closeModal()
          this.$swal({text: data.message, type: 'error'})
        }
      },
      async submitData (evt) {
        // Prevent modal from closing
        evt.preventDefault()
        if (this.isValid()) {
          const professionalTipData = {
            order_id: this.order.id,
            user_id: this.order.user_id,
            professional_id: this.order.professional_id,
            professional_income: Number(this.tipAmount),
            amount: Number(this.totalTip),
            payment_method: this.paymentMethod
          }

          if (this.paymentMethod === 'credit_card') {
            // User has no saved credit card
            if (!this.payment) {
              if (this.$refs.paymentForm.paymentFormValidation()) {
                this.isLoading = true
                // Prepare card data
                const cardNumber = this.paymentData.number.replace(/\s+/g, '')
                const arrExpiration = this.paymentData.expirationDate.split('/')
                const expirationMonth = arrExpiration[0]
                const expirationYear = 2000 + parseInt(arrExpiration[1])

                const card = {
                  name: this.paymentData.name,
                  number: cardNumber,
                  expiration_month: expirationMonth,
                  expiration_year: expirationYear,
                  security_code: this.paymentData.securityCode
                }

                // Set temp professional tip data
                this.$store.commit('orderDetail/SET_TMP_PROFESSIONAL_TIP_DATA', professionalTipData)

                // Perform omise process
                this.omiseTokens.secureToken = null
                this.omiseTokens.token = null
                // Get token from omise secure for otp
                window.Omise.setPublicKey(this.globalState.omisePublicKey)
                window.Omise.createToken('card', card, (statusCode, response) => {
                  if (statusCode === 200 && response.object === 'token') {
                    const omiseToken = response.id
                    this.omiseTokens.secureToken = omiseToken
                    // console.log('check omise token', omiseToken)
                    // Get token from omise non-secure for adding omise customer id
                    window.Omise.setPublicKey(this.globalState.omisePublicKey)
                    window.Omise.createToken('card', card, (statusCode, response) => {
                      if (statusCode === 200 && response.object === 'token') {
                        this.isLoading = false
                        const omiseToken = response.id
                        this.omiseTokens.token = omiseToken
                        this.$store.commit('payment/SET_TMP_OMISE_TOKEN', omiseToken)
                      } else {
                        this.isLoading = false
                        const alertText = 'Error: ' + response.message
                        this.$swal({text: alertText, type: 'error'})
                      }
                    })
                  } else {
                    const alertText = 'Error: ' + response.message
                    this.$swal({text: alertText, type: 'error'})
                    this.isLoading = false
                  }
                })
              }
            } else {
              this.isLoading = true
              const {data} = await axios.post('/professional-tips', professionalTipData)
              this.isLoading = false
              if (!data.error) {
                this.clearData()
                await this.loadOrderDetail(this.order.id)
                this.displayCompleteDialog()
              }
            }
          } else if (this.paymentMethod === 'promptpay') {
            this.isLoading = true
            await axios.post('/professional-tips', professionalTipData)
            this.isLoading = false
          }
        }
      },
      displayCompleteDialog () {
        this.$swal({
          imageUrl: '/static/img/thank-give-tip.png',
          imageHeight: 180,
          title: this.$i18n.t('message.professional_tip.thank_dialog_title'),
          text: this.$i18n.t('message.professional_tip.thank_dialog_message'),
          confirmButtonColor: '#17a2b8'
        })
      },
      async updateQrPaymentData () {
        clearInterval(this.checkingQrPayment)
        if (this.paymentMethod === 'promptpay') {
          const url = '/professional-tips'
          const submitData = {
            order_id: this.order.id,
            user_id: this.order.user_id,
            professional_id: this.order.professional_id,
            professional_income: Number(this.totalTip),
            amount: Number(this.totalTip),
            payment_method: this.paymentMethod
          }
          let {data} = await axios.post(url, submitData)
          if (data.error) {
            this.$swal({text: data.message, type: 'error'})
          } else {
            // insert
            const qrPaymentData = {
              amount: Number(this.totalTip),
              professional_tip_id: data.professional_tip.id
            }
            this.$refs.qrCodePayment.loadQrCode(qrPaymentData)
          }
        }
      },
      checkQrPayment (response) {
        this.qrResponse = response
        if (this.checkingQrPayment !== null) {
          clearInterval(this.checkingQrPayment)
          this.checkingQrPayment = null
        }
        this.checkingQrPayment = setInterval(() => {
          const url = '/qr-payments'
          axios
            .get(url, {
              params: {transaction_code: this.qrResponse.partnerTxnUid}
            })
            .then(async (res) => {
              const response = res.data
              if (!response.error) {
                if (response.qr_payment && response.qr_payment.status_code) {
                  if (response.qr_payment.status_code === '00') {
                    clearInterval(this.checkingQrPayment)
                    await this.loadOrderDetail(this.order.id)
                    this.closeModal()
                    this.displayCompleteDialog()
                  } else if (response.qr_payment.status_code === '10') {
                    clearInterval(this.checkingQrPayment)
                    const alertMessage = `Error: ${response.qr_payment.error_description}`
                    this.$swal({text: alertMessage, type: 'error'})
                    // if error set qr code timeout to be expired
                    this.$refs.qrCodePayment.finishTimer()
                  }
                }
              } else {
                clearInterval(this.checkingQrPayment)
              }
            })
            .catch(error => {
              console.log('error', error)
            })
        }, 7000)
      }
    },
    beforeDestroy () {
      clearInterval(this.checkingQrPayment)
    }
  }
</script>
<style lang="scss" scoped>
  .pillTip {
    background-color: #E0E0E0;
  }

  .active-button {
    background-color: #00BCD4;
  }
</style>



// WEBPACK FOOTER //
// src/components/order/components/ProfessionalTipSection.vue